export class Config {
    listNumber: true;
    action: any[] = [];
    resource: { name: string, code: string, canActive: boolean, metas: any[] }[];

    constructor(permission?: any[], resourceList?: any) {
        this.resource = resourceList ? Object.keys(resourceList).map(
            x => ({name: null, code: x, canActive: false, metas: []})) : [];
        // æ¥çèµæºåè¡¨ä¸­é£äºæ¯éè¦æ¿æ´»ç
        if (permission) {
            for (const key of this.resource) {
                permission.map(x => {
                    if (key.code === x.code) {
                        key.canActive = true;
                        key.name = x.name;
                        key.metas = x.metas;
                    }
                });
            }
        }
        // ææ¿æ´»ä¸­çåé¡µåè¡¨ä¸­çACTIONéåºæ¥
        this.resource.filter(x => x.canActive === true).map(y => {
            if (resourceList[y.code] === 'list') {
                this.action.push(y);
            }
        });
    }

    canActive(index: number) {
        return this.resource[index] ? this.resource[index].canActive : false;
    }

    metas(index: number) {
        return this.resource[index] ? this.resource[index].metas : false;
    }
}
